import React, { useEffect, useMemo, useState } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
  IconButton,
  Slide,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import { LoadingButton } from "@mui/lab";
import { DataGrid } from "@mui/x-data-grid";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import DriveFileRenameOutlineRoundedIcon from "@mui/icons-material/DriveFileRenameOutlineRounded";
import { VisibilityOffRounded, VisibilityRounded } from "@mui/icons-material";
import { toast } from "react-toastify";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { useDialog } from "../../../DialogContext";
import {
  deleteCategories,
  getCategories,
  updateCategories,
} from "../../../../redux/Apps/Lawyerapp/ActivitySlice/ActivitySlice";
import { backend_api } from "../../../../static/server";
import { compactGridStyle, pageScrollStyle } from "../../../../styles/styles";

const Transition = React.forwardRef((props, ref) => (
  <Slide direction="down" ref={ref} {...props} />
));

const ExpCategoriForm = () => {
  const { showDialog, closeDialog } = useDialog();
  const dispatch = useDispatch();
  const [showList, setShowList] = useState(true);
  const [isSubmiting, setIsSubmiting] = useState(false);
  const [isEditMode, setIsEdtiMode] = useState(false);
  const [editId, setEditId] = useState(null);
  const [deleteId, setDeleteId] = useState(null);
  const [openCnfDelete, setOpenCnfDelete] = useState(false);
  const [deleteLoad, setDeleteLoad] = useState(false);
  const { token } = useSelector((data) => data.user);
  const { allCategories, loading } = useSelector((state) => state.activity);

  useEffect(() => {
    dispatch(
      getCategories({
        url: `${backend_api}firm-case/expense-category/`,
        token: token,
      })
    );
  }, [dispatch, token]);

  const {
    control,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm();

  const onSubmit = async (data) => {
    setIsSubmiting(true); // Start submitting state

    try {
      if (isEditMode) {
        // If in edit mode, update the category
        await dispatch(
          updateCategories({
            url: `${backend_api}firm-case/expense-category/${editId}/`,
            data: data,
            token: token,
          })
        );
        toast.success("Category updated successfully");
        reset();
      } else {
        await axios.post(`${backend_api}firm-case/expense-category/`, data, {
          headers: {
            Authorization: `Token ${token}`,
          },
        });
        toast.success("New category added successfully");
        reset();
      }
      closeDialog();
      dispatch(
        getCategories({
          url: `${backend_api}firm-case/expense-category/`,
          token: token,
        })
      );
    } catch (error) {
      toast.error(
        isEditMode ? "Failed to update category" : "Failed to create category"
      );
    } finally {
      setIsSubmiting(false);
    }
  };

  const toggleShowList = () => {
    setShowList((prevState) => !prevState);
  };
  const handleEditCategory = (item) => {
    setIsEdtiMode(true);
    setEditId(item?.id);
    showDialog(<ExpCategoriForm />, {
      dialogTitle: "Edit expence category",
    });
    setValue("name", item?.row?.name);
    setValue("description", item?.row?.description);
  };
  const handleDelete = (id) => {
    setDeleteId(id);
    setOpenCnfDelete(true);
  };
  const handleDeleteCateogry = async () => {
    setDeleteLoad(true);
    try {
      await dispatch(
        deleteCategories({
          url: `${backend_api}firm-case/expense-category/${deleteId}/`,
          token: token,
        })
      );
      toast.success("category deleted successfully");
      setDeleteLoad(false);
      dispatch(
        getCategories({
          url: `${backend_api}firm-case/expense-category/`,
          token: token,
        })
      );
    } catch (error) {
      toast.error(error?.message || "Failed to delete category");
    } finally {
      setOpenCnfDelete(false);
    }
  };
  const columns = [
    {
      field: "actions",
      headerName: "Actions",
      width: 100,
      sortable: false,
      headerAlign: "left",
      renderCell: (item) => (
        <>
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
              gap: "0.2rem ",
              width: "100%",
            }}
          >
            <Tooltip title="Edit">
              <IconButton
                color="primary"
                size="small"
                onClick={() => {
                  handleEditCategory(item);
                }}
              >
                <DriveFileRenameOutlineRoundedIcon sx={{ fontSize: "1rem" }} />
              </IconButton>
            </Tooltip>
            <Tooltip title="Delete">
              <IconButton
                color="primary"
                size="small"
                aria-label="more"
                onClick={() => handleDelete(item?.id)}
              >
                <DeleteRoundedIcon sx={{ fontSize: "1rem" }} />
              </IconButton>
            </Tooltip>
          </Box>
        </>
      ),
    },
    {
      field: "name",
      headerName: "Category Name",
      width: 250,
    },
    { field: "description", headerName: "Description", width: 200 },
  ];
  const rows = useMemo(() => {
    if (!Array.isArray(allCategories)) {
      console.error("filteredCont is not an array:", allCategories);
      return [];
    }
    return (
      allCategories?.map((item) => ({
        id: item?.id ?? "-",
        name: item?.name ?? "-",
        description: item?.description ?? "-",
      })) ?? []
    );
  }, [allCategories]);

  return (
    <>
      <Box sx={{ position: "relative" }}>
        <Box sx={{ pt: "1rem", px: "1rem" }}>
          <Accordion
            expanded={showList}
            onChange={toggleShowList}
            sx={{
              p: "0rem",
              boxShadow: "none",
              border: "1px solid #e5e5e5",
            }}
          >
            <AccordionSummary
              expandIcon={
                showList ? (
                  <VisibilityOffRounded sx={{ fontSize: "1rem", margin: 0 }} />
                ) : (
                  <VisibilityRounded sx={{ fontSize: "1rem", margin: 0 }} />
                )
              }
              sx={{
                padding: "0rem 0.5rem",
                minHeight: "1.5rem !important",
                height: "1.5rem",
                "& .MuiAccordionSummary-content": {
                  margin: 0,
                  minHeight: "1.5rem",
                },
              }}
            >
              <Typography
                component="span"
                sx={{ fontSize: "0.8rem", fontWeight: 600 }}
              >
                Exist Categories
              </Typography>
            </AccordionSummary>
            <AccordionDetails
              sx={{
                padding: "0rem",
                height: "250px",
                // Remove overflow auto from here
                display: "flex",
                flexDirection: "column",
              }}
            >
              <div style={{ height: "100%", width: "100%" }}>
                <DataGrid
                  rows={rows}
                  columns={columns}
                  loading={loading}
                  pageSize={30}
                  slotProps={{
                    loadingOverlay: {
                      variant: "skeleton",
                      noRowsVariant: "skeleton",
                      rowCount: 30,
                    },
                  }}
                  initialState={{
                    pinnedColumns: {
                      left: ["desk"],
                    },
                    pagination: {
                      paginationModel: { pageSize: 30 },
                    },
                  }}
                  disableRowSelectionOnClick
                  disableSelectionOnClick
                  sx={{
                    ...compactGridStyle,
                    height: "100%",
                    width: "100%",
                    "& .MuiDataGrid-main": {
                      overflow: "auto",
                      ...pageScrollStyle,
                    },
                    "& .MuiDataGrid-columnHeaders": {
                      position: "sticky",
                      top: 0,
                      zIndex: 1,
                    },
                    "& .MuiDataGrid-footerContainer": {
                      position: "sticky",
                      bottom: 0,
                      zIndex: 1,
                      backgroundColor: "#fff",
                    },
                  }}
                />
              </div>
            </AccordionDetails>
          </Accordion>
        </Box>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "1rem",
              p: "1rem",
            }}
          >
            <Controller
              name="name"
              control={control}
              defaultValue=""
              rules={{ required: "Category Name is required" }}
              render={({ field }) => (
                <TextField
                  size="small"
                  {...field}
                  label={
                    <span>
                      Category Name<span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  fullWidth
                  error={!!errors?.name}
                  helperText={errors?.name?.message}
                />
              )}
            />

            {/* <Box sx={{ display: "flex", gap: "1rem" }}>
              <Controller
                name="billing_method"
                control={control}
                rules={{ required: "Billing method is required" }}
                render={({ field }) => (
                  <FormControl
                    size="small"
                    fullWidth
                    error={!!errors?.billing_method}
                  >
                    <InputLabel id="billing_method-label">
                      Billing Method
                    </InputLabel>
                    <Select {...field} labelId="billing_method-label">
                      <MenuItem value={"default_rate"}>
                        Use Default rate
                      </MenuItem>
                      <MenuItem value={"custom_rate"}>Custom rate</MenuItem>
                      <MenuItem value={"flat_rate"}>Flat rate</MenuItem>
                    </Select>
                    {errors?.billing_method && (
                      <FormHelperText>
                        {errors.billing_method.message}
                      </FormHelperText>
                    )}
                  </FormControl>
                )}
              />
              <Controller
                name="rate"
                control={control}
                defaultValue=""
                rules={{ required: "Rate is required" }}
                render={({ field }) => (
                  <TextField
                    size="small"
                    {...field}
                    label="Rate"
                    type="number"
                    fullWidth
                    error={!!errors?.rate}
                    helperText={errors?.rate?.message}
                    InputProps={{
                      startAdornment: <Typography sx={{ mr: 1 }}>$</Typography>,
                    }}
                  />
                )}
              />
            </Box> */}
            <Controller
              name="description"
              control={control}
              defaultValue=""
              rules={{ required: "Description is required" }}
              render={({ field }) => (
                <TextField
                  size="small"
                  {...field}
                  label={
                    <span>
                      Description<span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  multiline
                  rows={3}
                  fullWidth
                  error={!!errors?.description}
                  helperText={errors?.description?.message}
                />
              )}
            />
          </Box>

          <Box
            sx={{
              height: "fit-content",
              borderTop: "1px solid #ddd",
              position: "sticky",
              bottom: 0,
              backdropFilter: "blur(10px)",
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              p: "0.5rem",
              zIndex: 1000,
              gap: "1rem",
            }}
          >
            <Button variant="outlined" onClick={closeDialog} size="small">
              Cancel
            </Button>
            <LoadingButton
              loading={isSubmiting}
              variant="contained"
              color="primary"
              type="submit"
              size="small"
            >
              {isEditMode ? "Update category" : "Save category"}
            </LoadingButton>
          </Box>
        </form>
      </Box>
      {/* ---------------------------- CONFORMATION DIALOG ---------------------------- */}
      <Dialog
        open={openCnfDelete}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => setOpenCnfDelete(false)}
      >
        <DialogTitle>Sure you want to delete this expence Cateogry</DialogTitle>
        <DialogActions>
          <Button size="small" variant="outlined" color="primary">
            Edit
          </Button>

          {deleteLoad ? (
            <LoadingButton size="small" loading variant="contained">
              Delete
            </LoadingButton>
          ) : (
            <Button
              size="small"
              variant="contained"
              color="error"
              onClick={() => handleDeleteCateogry(deleteId)}
            >
              Delete
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ExpCategoriForm;
